var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-users" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("users_groups")) + "\n\t")
        ],
        1
      ),
      _c("q-table", {
        attrs: {
          data: _vm.groups,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    icon: "fas fa-search",
                    placeholder: _vm.$t("search"),
                    debounce: 500
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "fas fa-plus",
                    label: _vm.$t("new")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "admin_users_group",
                        params: { id: 0 }
                      })
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c("q-td", { key: "id", attrs: { props: props } }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t")
                  ]),
                  _c("q-td", { key: "title", attrs: { props: props } }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(props.row.title) + "\n\t\t\t")
                  ]),
                  _c("q-td", { key: "qty_members", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(props.row.qty_members) + "\n\t\t\t"
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "fas fa-pencil-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "admin_users_group",
                                params: { id: props.row.actions }
                              })
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "negative",
                            icon: "far fa-trash-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRemove(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }